"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoilProToolContainerComponent = CoilProToolContainerComponent;
const React = __importStar(require("react"));
const property_1 = require("@genesys/property");
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const Actions = __importStar(require("./actions"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Types = __importStar(require("./types"));
const ResultScreenSelector = __importStar(require("./result-screen-selector"));
const DataUpload = __importStar(require("@genesys/client-core/lib/data-upload"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const input_file_1 = require("./input-file");
const property_definitions_1 = require("./property-definitions");
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const GenesysPropertiesSelectorRenderers = __importStar(require("@genesys/client-core/lib/genesys-properties-selector-renderers"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const FieldGroups = __importStar(require("./field-groups"));
const Express = __importStar(require("./express"));
/** The values an express run walks are numbered: `pressure_0`, `flow_1`, and so on. */
const indexedProperty = /^(.+)_(\d+)$/;
const coilTypeLabel = {
    fluid: "Fluid",
    dx: "DX",
    condenser: "Condenser",
    steam: "Steam"
};
/**
 * A key is `coilprotool_<segment>_<name>`. The segment comes from the panel a property is
 * rendered in rather than from its name, so two coil sides can each own a `subcoolingtemp` and
 * still ask for a label of their own.
 */
function translationFor(segment) {
    const key = (name) => `coilprotool_${segment}_${name}`;
    return {
        propertyName: (propertyName, translate) => {
            const indexed = indexedProperty.exec(propertyName);
            if (indexed) {
                return (translate(LanguageTexts.globalPropertyName(key(indexed[1]))) +
                    ` ${+indexed[2] + 1}`);
            }
            return translate(LanguageTexts.globalPropertyName(key(propertyName)));
        },
        propertyValue: (propertyName, propertyValue, translate) => {
            return translate(LanguageTexts.globalPropertyName(key(propertyName) + "_" + propertyValue));
        }
    };
}
function CoilProToolContainerComponent(props) {
    const onModeChange = (mode) => props.dispatch(Actions.setToolMode(mode));
    const onModeCalculate = () => onModeChange("calculate");
    const onModeExpress = () => onModeChange("express");
    const onModeCalculateExpress = () => onModeChange("express-calculate");
    const onCalculate = createOnCalculate(props);
    const onExpressCalculate = createOnExpressCalculate(props);
    const onCoilTypeChange = (coilType) => props.dispatch(Actions.setCoilType(coilType));
    const onImportFile = (res) => props.dispatch(Actions.setPropertiesFromFile((0, input_file_1.parseFile)(res)));
    const selectedProperties = props.pvses[0];
    const panels = (0, property_definitions_1.getPropertyDefinitions)(selectedProperties, props.mode, props.coilType);
    return (React.createElement(Contexts.clientConfigContext.Consumer, null, config => (React.createElement(Contexts.ScreenAmountProfileContext.Consumer, null, screenProfile => {
        const si = screenProfile.measureSystem === 1;
        return (React.createElement(Elements.ScrollContainer, null,
            React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
                React.createElement(Elements.FlexContainerStack, { center: false },
                    React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
                        React.createElement(Elements.InnerContainer, null,
                            React.createElement("label", null,
                                React.createElement("input", { type: "radio", name: "mode", checked: props.mode === "calculate", onChange: () => onModeCalculate() }),
                                "Calculate coil")),
                        React.createElement(Elements.InnerContainer, null,
                            React.createElement("label", null,
                                React.createElement("input", { type: "radio", name: "mode", checked: props.mode === "express", onChange: () => onModeExpress() }),
                                "Express")),
                        React.createElement(Elements.InnerContainer, null,
                            React.createElement("label", null,
                                React.createElement("input", { type: "radio", name: "mode", checked: props.mode === "express-calculate", onChange: () => onModeCalculateExpress() }),
                                "Calculate coil Express"))),
                    props.mode !== "express" && (React.createElement(Elements.FlexContainerRowWithPadding, { center: false }, Types.coilTypesFor(props.mode).map(coilType => (React.createElement(Elements.InnerContainer, { key: coilType },
                        React.createElement("label", null,
                            React.createElement("input", { type: "radio", name: "coiltype", checked: props.coilType === coilType, onChange: () => onCoilTypeChange(coilType) }),
                            coilTypeLabel[coilType])))))),
                    props.mode !== "express" && (React.createElement(Elements.InnerContainer, null,
                        props.coilType === "fluid" ? (React.createElement("img", { src: "/assets/images/coilpro/fluid-coils.png" })) : (React.createElement("img", { src: "/assets/images/coilpro/dx-coils.png" })),
                        React.createElement(Elements.FlexContainerRowWithPadding, { center: false }, panels.map(panel => (React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { key: panel.key, selectedProperties: selectedProperties, productProperties: panel.properties, 
                            // A selector keeps its amount formats under one field group, so
                            // each column is a selector of its own.
                            screenAmountProfileFieldGroup: FieldGroups.FieldGroupOf[panel.segment], onChange: pvs => props.dispatch(Actions.setProperties(pvs)), customTranslation: translationFor(panel.segment), uniqueId: `CoilProTool-${panel.key}`, readOnlyProperties: panel.readonly, layoutRenderer: GenesysPropertiesSelectorRenderers.columnsStackedWithGroupsLayoutRenderer, sections: {
                                [panel.key]: { groups: panel.groups }
                            } })))))),
                    props.mode === "calculate" && (React.createElement(Elements.FlexContainerRowWithPadding, null,
                        React.createElement(Elements.FlexContainerStack, null,
                            React.createElement(Elements.StandardButton, { onClick: () => onCalculate() }, "Calculate coil"),
                            React.createElement(DataUpload.SimpleDataUploadContainer, { onParsed: res => onImportFile(res) }, onClick => (React.createElement(Elements.StandardButton, { onClick: onClick }, "Import"))),
                            React.createElement(Exporter.XlsxSingleSheetExport, { data: (0, input_file_1.inputsToFile)(props.coilType, props.pvses[0]), filename: "CoilPro_inputs" }, onClick => (React.createElement(Elements.StandardButton, { onClick: () => onClick() }, "Download")))))),
                    props.mode === "express" && (React.createElement(Express.Component, { si: si, graphqlEndpoint: config.graphqlEndpoint, authorization: config.authorization })),
                    props.mode === "express-calculate" && (React.createElement(Elements.FlexContainerRowWithPadding, null,
                        React.createElement(Elements.FlexContainerStack, null,
                            React.createElement(Elements.StandardButton, { onClick: () => onExpressCalculate() }, "Calculate coil")))),
                    props.mode !== "express" && (React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
                        React.createElement(ResultScreenSelector.SelectScreen, { pvses: props.pvses, resultScreen: props.resultScreen })))))));
    }))));
}
/** Max performance, or modulating to a target temperature. */
function isMaxPerformance(pvs) {
    return property_1.PropertyValueSet.getInteger("calculationmethod", pvs) === 0;
}
const calculateScreen = {
    fluid: {
        maxPerformance: "FluidMaxPerformanceResult",
        targetTemperature: "FluidTargetTemperatureResult"
    },
    dx: {
        maxPerformance: "DxMaxPerformanceResult",
        targetTemperature: "DxTargetTemperatureResult"
    },
    condenser: {
        maxPerformance: "CondensorMaxPerformanceResult",
        targetTemperature: "CondensorTargetTemperatureResult"
    },
    steam: {
        maxPerformance: "SteamMaxPerformanceResult",
        targetTemperature: "SteamTargetTemperatureResult"
    }
};
function createOnCalculate(props) {
    const screens = calculateScreen[props.coilType];
    const screen = isMaxPerformance(props.pvses[0])
        ? screens.maxPerformance
        : screens.targetTemperature;
    return () => props.dispatch(Actions.calculateCoil(screen));
}
/**
 * Express walks one input and calculates the rest. A fluid coil steps its own outlet temperature
 * or its flow; a steam coil steps the steam pressure, the inlet temperature or the inlet
 * humidity. CoilPro's DX and condenser take no sweep, so the button does nothing for those.
 */
function createOnExpressCalculate(props) {
    const pvs = props.pvses[0];
    const maxPerformance = isMaxPerformance(pvs);
    if (props.coilType === "fluid") {
        // 0 = Temperature out, 1 = Flow
        const byFlow = property_1.PropertyValueSet.getInteger("temperatureflow", pvs) === 1;
        const screen = maxPerformance
            ? byFlow
                ? "ExpressCalcFlowFluidMaxPerformanceResult"
                : "ExpressCalcTemperatureOutFluidMaxPerformanceResult"
            : byFlow
                ? "ExpressCalcFlowFluidTargetTemperatureResult"
                : "ExpressCalcTemperatureOutFluidTargetTemperatureResult";
        return () => props.dispatch(Actions.calculateCoil(screen));
    }
    if (props.coilType === "steam") {
        // 0 = Steam pressure, 1 = Inlet temperature, 2 = Inlet humidity
        const stepped = property_1.PropertyValueSet.getInteger("stepproperty", pvs);
        const screens = maxPerformance
            ? [
                "ExpressCalcPressureSteamMaxPerformanceResult",
                "ExpressCalcTemperatureSteamMaxPerformanceResult",
                "ExpressCalcHumiditySteamMaxPerformanceResult"
            ]
            : [
                "ExpressCalcPressureSteamTargetTemperatureResult",
                "ExpressCalcTemperatureSteamTargetTemperatureResult",
                "ExpressCalcHumiditySteamTargetTemperatureResult"
            ];
        const screen = screens[stepped];
        if (!screen) {
            throw new Error(`No express screen steps property ${stepped}`);
        }
        return () => props.dispatch(Actions.calculateCoil(screen));
    }
    // This is built on every render, whatever mode the tool is in, so the complaint has to wait
    // until the button is actually pressed - which it cannot be, since express does not offer
    // these coil types in the first place.
    return () => {
        throw new Error(`Express has no sweep for a ${props.coilType} coil`);
    };
}
//# sourceMappingURL=container-component.js.map